import { coreUsersAllGetAsyncSlice } from './get';
import { createUpdateCollectionSyncSlice } from '@sonar-software/xuder';

import { PatchUserRequest, PostUserChangePermissionRequest } from '@api';

export const updateUsersAllSyncSlice = createUpdateCollectionSyncSlice({
	hasRequest: true,
	name: 'CoreUsersAll',
	state: coreUsersAllGetAsyncSlice.asyncState,
	target: (request: PatchUserRequest) => (user) => user.id === request.userId,
	update: (request: PatchUserRequest | PostUserChangePermissionRequest) => (user) => ({
		...user,
		email: (request as PatchUserRequest).email ?? user.email ?? '',
		firstName: (request as PatchUserRequest).firstName ?? user.firstName ?? '',
		isLocked: (request as PostUserChangePermissionRequest).isLocked ?? user.isLocked ?? false,
		isReadOnly: (request as PostUserChangePermissionRequest).isReadOnly ?? user.isReadOnly ?? true,
		lastName: (request as PatchUserRequest).lastName ?? user.lastName ?? ''
	})
});
